<template>
  <div class="page">
    <div
      class="zhezhao"
      @click="onCancel"
    ></div>
    <div class="selbox">
      <p class="title">{{title}}</p>

      <div class="body">
        <div class="body-line"><span>*</span> 计划时间 <input
            @click="showTimePicker"
            v-model="dataSource.begin_time"
            class="body-input"
            placeholder="请输入时间"
          /> </div>
        <div class="body-line"><span>*</span> 计划签约金额(万) <input
            v-model="dataSource.sign"
            class="body-input"
            placeholder="请输入金额"
          /> </div>
        <div class="body-line"><span>*</span> 计划回款金额(万) <input
            v-model="dataSource.back"
            class="body-input"
            placeholder="请输入金额"
          /> </div>
        <div class="body-line"><span>*</span> 计划开票金额(万) <input
            v-model="dataSource.invoice"
            class="body-input"
            placeholder="请输入金额"
          /> </div>
        <div class="body-line"><span>*</span> 计划交付金额(万) <input
            v-model="dataSource.delivery"
            class="body-input"
            placeholder="请输入金额"
          /> </div>
      </div>
      <!-- 时间选择 -->
      <mt-popup
        v-model="timePopupVisible"
        position="bottom"
        popup-transition="popup-fade"
        style="width:100%"
      >
        <mt-picker
          :slots="slots"
          @change="onDateChange"
          valueKey="name"
        ></mt-picker>
        <div class="footer">
          <span @click="timePopupVisible = false">取消</span>
          <span
            style="color:#5482D2;"
            @click="timeConfirm"
          >确认</span>
        </div>
      </mt-popup>
      <p
        class="btnyes"
        @click="confirmFilter"
      >确定</p>
    </div>
  </div>
</template>
<script>
import { Popup, Picker } from 'mint-ui'
import Vue from 'vue'
import slotsList from '../../../assets/js/slotsList'
import dateChange from '../../../mixins/dateChange.js'
import { convertFormat } from '../../../assets/js/date'
import { MessageBox } from 'mint-ui'
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
export default {
  mixins: [slotsList, dateChange],

  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      slots: null,
      isFilter: false,
      timePopupVisible: false,
      title: '录入数据',
      dataSource: {
        begin_time: '',
        sign: '',
        back: '',
        invoice: '',
        delivery: '',
      }
    }
  },

  created() {
    this.slots = slotsList.singleMonthslots(this.info.begin_time)
    this.getPlanInfo()
  },
  methods: {
    getPlanInfo() {
      this.$http.getPlanInfoApi({ begin_time: convertFormat(this.info.begin_time) }).then(res => {
        this.dataSource = { ...res.data }
        this.dataSource.begin_time = this.info.begin_time
      })
    },
    showTimePicker() {
      this.timePopupVisible = true
    },
    timeConfirm() {
      this.dataSource.begin_time = this.c_begin_time
      this.timePopupVisible = false
    },
    onCancel() {
      this.$emit('cancel')
    },
    confirmFilter() {
      this.dataSource.begin_time = convertFormat(this.dataSource.begin_time)
      this.$http.postPlanInfoApi({ ...this.dataSource }).then(res => {
         this.$notice.tip('编辑成功')
        this.isFilter = false
        this.$emit('ok')
        this.$emit('cancel')
      }).catch(err => {
         this.$notice.tip(err)
      })

    }
  }
}
</script>
<style scoped>
.page {
  width: 100%;
  height: 100%;
}
.body {
  padding: 20px;
}
.body-line {
  text-align: left;
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}
.body-line span {
  font-size: 12px;
  color: #f00;
}
.body-input {
  width: 200px;
  height: 30px;
  line-height: 30px;
  margin-top: 4px;
  font-size: 12px;
  padding-left: 4px;
  color: #666;
  border: 1px solid #eee;
  border-radius: 4px;
}
.footer {
  width: 100%;
  height: 1.25rem;
  font-size: 0;
}
.footer span {
  width: 50%;
  height: 1.125rem;
  font-size: 0.5rem;
  line-height: 1.25rem;
  display: inline-block;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/components/input-right.vue